import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=0bf8c708&scoped=true&"
import script from "./Iframe.vue?vue&type=script&lang=js&"
export * from "./Iframe.vue?vue&type=script&lang=js&"
import style0 from "./Iframe.vue?vue&type=style&index=0&id=0bf8c708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8c708",
  null
  
)

export default component.exports